import React, { memo } from 'react';
import moment from 'moment';
import { AlgoliaModifiedQueryData } from '../../interfaces/AlgoliaModifiedQueryData.interface';
import CustomLink from '../CustomLink/CustomLink';
import Image from '../Image/Image';
import Heading, { HeadingTypes } from '../Heading/Heading';
import { pushToDataLayer } from '../../utils/pushToDataLayer/pushToDataLayer.util';
import SbImage from '../SbImage/SbImage';

interface ArticleIndexPageResultCardProps {
  article: AlgoliaModifiedQueryData;
}

const ArticleIndexPageResultCard: React.FC<ArticleIndexPageResultCardProps> = ({
  article,
}) => {
  const {
    image,
    subcategory_tags,
    full_slug,
    heading,
    body,
    read_time,
    published_at,
    published_at_timestamp,
    updated_at,
  } = article;

  const handleDataLayerClickEvent = (articleTitle: string): void => {
    pushToDataLayer({
      event: 'article_click',
      data: { article_title: articleTitle },
    });
  };

  return (
    <CustomLink
      url={full_slug}
      label={heading}
      className="space-y-8 group"
      onClick={() => handleDataLayerClickEvent(heading)}
    >
      <div className="w-full aspect-[3/2] bg-border/light">
        {image && (
          <SbImage
            asset={image}
            options={{
              objectFit: 'cover',
              width: 600,
              height: 400,
              sizes: { base: 1200 },
            }}
          />
        )}
      </div>
      <div className="space-y-4">
        <div className="space-y-2 text-text/body">
          {heading && (
            <Heading
              text={heading}
              headingType={HeadingTypes.h2}
              headingStyleType={HeadingTypes.h4}
            />
          )}
          {(updated_at || read_time) && (
            <div className="flex items-center justify-start text-text/body-tint text-sm">
              {updated_at && <p>{updated_at}</p>}
              {updated_at && read_time && <span className="px-2">-</span>}
              {read_time && <p>{read_time} min read</p>}
            </div>
          )}
        </div>
        {body && <p className="text-body">{body}</p>}
      </div>
    </CustomLink>
  );
};

export default memo(ArticleIndexPageResultCard);
